import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, Dependencies, TaskItem, TasksMethod, TasksResponse } from '../types';
import { GetRowsRequest, GetSummaryResponse, UpdateSettingsRequest, UpdateSettingsResponse } from '../../../grid/types/common';
import { ConsoleRequest, DataProviderType, FilterKeyMapper } from '../../../utils/request';
import { API_TYPE_QUARANTINE } from '../../../webcomponents.constants';

export class TasksGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private endpoint = 'Tasks';
  private cache: TasksResponse | null;
  public companyFilterDataProvider = API_TYPE_QUARANTINE;

  /**
   * Maps column key to different filter key as we filter with a different one.
   */
  private filterKeyMapper: FilterKeyMapper = {
    'companies.name': 'companies.id',
  };

  constructor(public dependencies: Dependencies) {
    super();
  }

  async getSummary(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetSummaryResponse> {
    const response = await this.readRecords(request);
    return {
      numItems: response.total,
      summary: '',
    };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<{ rawEvents: Array<TaskItem> }> {
    const response = await this.readRecords(request);
    return { rawEvents: response.data };
  }

  async setFilters(request: any): Promise<{} | undefined> {
    return;
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }

  private async readRecords(request: GetRowsRequest<Column, ColumnKeys>): Promise<TasksResponse> {
    if (this.cache) {
      //tslint:disable-next-line:no-shadowed-variable
      const response = Promise.resolve(this.cache);
      this.cache = null;

      return response;
    }

    const payload = ConsoleRequest.mapGridRequestToPayload(
      request,
      this.dependencies.getTimezone(),
      this.filterKeyMapper
    );
    const response = await ConsoleRequest.createRequest<TasksResponse>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload,
      endpoint: this.endpoint,
      method: TasksMethod.READ_RECORDS,
    });

    this.cache = response;

    return response;
  }
}
